<template>
  <div v-if="viewStore.selfActive" id="faq" class="container">
    <h1>FAQs</h1>
    <div class="py-3">
      <div class="form-floating mb-3 w-50">
        <input
          class="form-control"
          id="floatingInput"
          placeholder="Wonach suchst du?"
          v-model="state.search"
        />
        <label for="floatingInput">Wonach suchst du?</label>
      </div>
    </div>

    <div
      class="accordion accordion-flush"
      style="min-height: 300px"
      id="accordionFlushFaq"
    >
      <!-- Loop -->
      <div v-if="currentRoute == '/podcast'">
        <div v-for="(faq, index) in filter" :key="faq" class="accordion-item">
          <h2 class="accordion-header py-2" :id="'flush-heading' + index">
            <button
              class="accordion-button collapsed"
              :class="[viewStore.isMobile ? 'ps-1 pe-1' : '']"
              data-bs-toggle="collapse"
              :data-bs-target="'#flush-collapse' + index"
              aria-expanded="false"
              :aria-controls="'flush-collapse' + index"
            >
              <span :class="[viewStore.isMobile ? 'pe-3 fs-5 ' : 'pe-5 fs-3']">
                {{ faq.question }}</span
              >
            </button>
          </h2>
          <div
            :id="'flush-collapse' + index"
            class="accordion-collapse collapse"
            :aria-labelledby="'flush-heading' + index"
            data-bs-parent="#accordionFlushFaq"
          >
            <div
              class="accordion-body"
              :class="[
                viewStore.isMobile
                  ? 'lh-base w-100 fs-6 pb-4 ps-1 pe-1'
                  : 'lh-lg w-75 pb-5 fs-5',
              ]"
            >
              {{ faq.answer }}
            </div>
          </div>
        </div>
      </div>

      <div v-if="currentRoute == '/hoerbuch'">
        <div
          v-for="(faq, index) in filterHoerbuch"
          :key="faq"
          class="accordion-item"
        >
          <h2 class="accordion-header py-2" :id="'flush-heading' + index">
            <button
              class="accordion-button collapsed"
              :class="[viewStore.isMobile ? 'ps-1 pe-1' : '']"
              data-bs-toggle="collapse"
              :data-bs-target="'#flush-collapse' + index"
              aria-expanded="false"
              :aria-controls="'flush-collapse' + index"
            >
              <span :class="[viewStore.isMobile ? 'pe-3 fs-5 ' : 'pe-5 fs-3']">
                {{ faq.question }}</span
              >
            </button>
          </h2>
          <div
            :id="'flush-collapse' + index"
            class="accordion-collapse collapse"
            :aria-labelledby="'flush-heading' + index"
            data-bs-parent="#accordionFlushFaq"
          >
            <div
              class="accordion-body"
              :class="[
                viewStore.isMobile
                  ? 'lh-base w-100 fs-6 pb-4 ps-1 pe-1'
                  : 'lh-lg w-75 pb-5 fs-5',
              ]"
            >
              {{ faq.answer }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, reactive } from "vue";
import { useViewStore } from "../stores/ViewStore";

const viewStore = useViewStore();

const router = useRouter();
const currentRoute = router.currentRoute.value.path;

const faqs = ref([
  {
    question: "Wie werden die Pakete abgerechnet?",
    answer:
      "Alle Pakete werden Netto und pro Folge berechnet. Individuelle Pakete können gerne direkt angefragt werden.",
  },
  {
    question:
      "Meine Podcastfolgen gehen gelegentlich länger, als in den Paketen angegeben?",
    answer:
      "Wir mögen keine Erbsenzähler. Falls die ein oder andere Folge mal etwas länger geht, ist das kein Problem. Überschreiten deine Folgen jedoch regelmäßig die Paketminuten, sind wir gezwungen einen kleinen Aufpreis zu verlangen.",
  },
  {
    question: "Gibt es eine Mindestlaufzeit?",
    answer:
      "Nein! Abos oder ähnliche Modelle finden wir uncool. Wir stellen nur Leistungen in Rechnung, wenn wir leisten! Du kannst jederzeit pausieren.",
  },
  {
    question: "Gibt es die Möglichkeit, ein Paket individuell zu erstellen?",
    answer:
      "Na klar. Schreib uns gerne. Wir schicken dir ein Angebot zu oder sprechen in einem Erstgespräch über ein individuelles Angebot.",
  },
  {
    question: "Wie und worüber erfolgt der Austausch der Dateien?",
    answer:
      "Wir arbeiten mit dem Cloud Service Google Drive. Dort werden alle Inhalte (Aufnahmen, Shownotes, Teaser, Metadaten o.ä) sicher gespeichert. Auch deine Mitarbeiter:innen erhalten auf Wunsch die Zugriffsrechte auf die Cloud. Falls du bereits mit einer anderen Cloud arbeitest, können wir nach Absprache deine Cloud nutzen.",
  },
  {
    question: "Wie lange dauert die Produktion einer Folge?",
    answer:
      "Alle notwendigen Materialien sollten 7 Tage vor einer Veröffentlichung für die Produktion vollständig bereit gestellt werden. In der Regel sind wir nach Abgabe der Aufnahmen innerhalb von 72 Stunden mit der Produktion fertig.",
  },
  {
    question: "Wie läuft die Zusammenarbeit ab?",
    answer:
      "Uns ist eine harmonische, respektvolle und persönliche Zusammenarbeit sehr wichtig. Nach dem Kennlerngespräch besprechen wir den Status Quo, schauen auf deine Wünsche & Ziele, auf das ZUSAMMEN und wie wir dich bestmöglich unterstützen können.",
  },
  {
    question:
      "Können auch Leistungen aus anderen Paketen übernommen/getauscht werden?",
    answer:
      "Ja! Die Pakete dienen als Richtlinie für die Leistung die wir anbieten. Schreib uns gerne hierfür eine Email an: podcast@voiceart-productions.com, ruf uns direkt an unter: +49 162 646593 oder buche dir ein kostenloses Erstgespräch.",
  },
  {
    question:
      "Mein Podcast wechselt regelmäßig zwischen verschiedenen Leistungen/Anforderungen? Wie wird das bei euch abgerechnet?",
    answer:
      "Keine Sorge! Wir stellen immer nur die entsprechende Leistung in Rechnung. Wenn du also bspw. mal keine Teaser brauchst, du die Shownotes selbst schreibst, dann berechnen wir das auch nicht.",
  },
  {
    question: "Wie läuft die Bezahlung bei euch?",
    answer:
      "Du erhältst monatlich eine übersichtliche Rechnung. Überwiesen wird via Banküberweisung. ",
  },
  {
    question:
      "Wie kann ich mich vergewissern, dass mein Podcast im Thema inhaltlich trittsicher bleibt?",
    answer:
      "Mit unseren kostenlosen Feedbackschleifen! Wir erstellen gerne eine erste Version deiner Folge, danach überprüfst du den Inhalt. Falls du Anmerkungen hast, senden wir dir deine Folge mit den inhaltlichen Anmerkungen bearbeitet zurück.",
  },
  // {
  //   question: "Ist die enge Betreuung in allen Paketen mit enthalten?",
  //   answer:
  //     "Ja! Wir sind davon überzeugt, dass eine professionelle Produktion in Kombination mit intensiver Betreuung den Erfolg ausmacht!",
  // },
  {
    question:
      "Ich möchte mich zunächst von eurer Qualität überzeugen lassen, bevor ich mich für ein Kennlerngespräch oder Zusammenarbeit entscheide! Was kann ich tun?",
    answer:
      "Das verstehen wir und probieren soll bei uns nichts kosten. Schick uns deine zu bearbeitende Episode (vollständig & mit allen wichtigen Infos) gern an podcast@voiceart-productions.com. Wir melden uns dann sehr zeitnah bei dir.",
  },
  // {
  //   question:
  //     "Für meinen Podcast benötige ich nur eine Soundoptimierung - ohne Schnitt",
  //   answer:
  //     'Kein Problem! Schick uns gerne eine Email mit dem Betreff "Podcast Mastering" an ' +
  //     "hello@voiceart-productions.com" +
  //     ". Nach der Eingangsmail melden wir uns bei dir!",
  // },
]);

const hFaqs = ref([
  {
    question: "Wo befindet sich das Tonstudio für die Hörbuchaufnahmen?",
    answer:
      "Das Studio liegt im Herzen von Berlin - im Stadtbezirk Prenzlauer Berg. Mehr Informationen findest auch unter http://www.jazzanovarecordingstudio.com/ ",
  },
  {
    question: "Welche Vorteile bietet eine Hörbuchproduktion?",
    answer:
      "Durch den schnellen und einfachen digitalen Vertrieb (Bookbeat, Audible, Amazon u.v.m) lassen sich Hörbücher und E-Books aus wirtschaftlicher Sicht - und im Vergleich zu analogen Büchern - besser verkaufen.",
  },
  {
    question: "Über welche digitalen Kanäle wird mein Buch vertrieben?",
    answer:
      "Durch unser großes Netzwerk haben wir die Möglichkeit dein Hörbuch auf allen  Digitalvertrieben zu veröffentlichen (Audible, Bookbeat, Amazon, Spotify,Podimo,Thalia u.v.m.)",
  },
  {
    question:
      "Ich möchte mein Hörbuch selbst einsprechen. Welche Vorteile ergeben sich?",
    answer:
      "Vorteile: Die Zuhörerschaft ist mit deiner Stimme vertraut. Dadurch wirkt das Hörbuch auf die Zuhörer:in persönlicher und authentischer, da es von dir eingesprochen wird. Die Kosten sind ein wenig geringer, da zusätzliche Kosten für die Sprecher:in entfallen.",
  },
  {
    question:
      "Ich möchte mein Hörbuch selbst einsprechen. Welche Nachteile ergeben sich?",
    answer:
      "Nachteile: Erfahrene bzw. ausgebildete Sprecher:in haben i.d.R eine für die Zuhörerschaft sehr angenehme Stimme. Sie wissen genau, wie sie Sprache, Stimmlage und Timing richtig einsetzen und so den Inhalt des Hörbuches auf den Punkt bringen. Die Kosten für Sprecher:in sind dementsprechend höher.",
  },
  {
    question: "Wie lange dauert die Produktion eines Hörbuches?",
    answer:
      "In der Regel ist die Produktion inkl. Aufnahme im Tonstudio innerhalb von 4 Wochen für die Veröffentlichung fertig.",
  },
  {
    question: "Wieviel kostet eine Hörbuchproduktion?",
    answer:
      'Eine Hörbuchproduktion ist immer von der Seitenanzahl (noch besser "Anzahl der Wörter"), Anzahl der Stimmen und von der Qualität der Sprecher:in abhängig. Unser Kostenrechner hilft dir dabei, die Kosten für dein Hörbuch zu schätzen.',
  },
  {
    question:
      "Muss ich Erfahrung mitbringen, wenn ich mein erstes selbst Hörbuch einsprechen möchte?",
    answer:
      "Irgendwann ist immer das erste mal, also kein Grund zur Sorge... In unserem Erstgespräch werden wir hierzu alles weitere besprechen.",
  },
]);

// let stringToHtml = (input) => {
//   let parser = new DOMParser();
//   return parser.parseFromString(input, "text/html").body;
// };

const state = reactive({
  search: null,
  array: faqs,
  hoerbuchFaqs: hFaqs,
});

const filter = computed(() => {
  if (state.search) {
    return state.array.filter((item) => {
      return state.search
        .toLowerCase()
        .split(" ")
        .every(
          (v) =>
            item.question.toLowerCase().includes(v) ||
            item.answer.toLowerCase().includes(v),
        );
    });
  } else {
    return state.array;
  }
});

const filterHoerbuch = computed(() => {
  if (state.search) {
    return state.hoerbuchFaqs.filter((item) => {
      return state.search
        .toLowerCase()
        .split(" ")
        .every(
          (v) =>
            item.question.toLowerCase().includes(v) ||
            item.answer.toLowerCase().includes(v),
        );
    });
  } else {
    return state.hoerbuchFaqs;
  }
});
</script>

<style scoped>
.accordion-button::after {
  width: 2rem;
  height: 2rem;
  margin-left: auto;
  background-image: url("../assets/svg/plus-lg.svg") !important;
  background-size: 2rem;
}

.accordion-button:not(.collapsed)::after {
  background-image: url("../assets/svg/plus-lg.svg") !important;
  transform: rotate(45deg) !important;
}

input {
  border: 2px solid black;
}

.accordion-button {
  font-weight: 700;
  font-size: 1.5rem;
}

.accordion-button:focus {
  outline: none;
  box-shadow: none;
}

h1 {
  font-size: 3rem;
  font-weight: 900;
}

#faq {
  margin-top: 6rem;
  margin-bottom: 6rem;
}

.accordion-button:not(.collapsed) {
  color: black;
  background-color: transparent;
  box-shadow: inset 0 calc(-1 * var(--bs-accordion-border-width)) 0
    var(--bs-accordion-border-color);
}

.accordion-button:not(.collapsed)::after {
  background-image: var(--bs-accordion-btn-icon);
  transform: var(--bs-accordion-btn-icon-transform);
}

.accordion-flush .accordion-item {
  border-right: 0;
  border-left: 0;
  border-bottom: 2px solid black;
  border-radius: 0;
}
</style>
